<script>
    import PriceInfo from "./PriceInfo.svelte";
    export let name;
    export let cpu;
    export let ram;
    export let paymentLink;
    export let paypalLink;

    export let name2;
    export let price2;
    export let cpu2;
    export let ram2;
    export let paymentLink2;
    export let paypalLink2;
    export let paypalLink2USE;
    export let paymentLink2DE;
    export let paypalLink2DE;
    export let paymentLink2USE;

    export let name3;
    export let price3;
    export let cpu3;
    export let ram3;
    export let paymentLink3;
    export let paypalLink3;
    export let paypalLink3USE;
    export let paymentLink3DE;
    export let paypalLink3DE;
    export let paymentLink3USE;

    export let name4;
    export let price4;
    export let cpu4;
    export let ram4;
    export let paymentLink4;
    export let paypalLink4;
    export let paypalLink4USE;
    export let paymentLink4DE;
    export let paypalLink4DE;
    export let paymentLink4USE;
</script>

<div class="min-h-screen flex justify-center items-center">
    <div class="">
        <div class="text-center font-semibold">
            <h1 class="text-5xl">
                <span class="text-blue-700 tracking-wide">Flexible </span>
                <span class="text-gray-50">Hosting</span>
            </h1>
            <p
                class="pt-6 text-xl text-gray-400 font-normal w-full px-8 md:w-full"
            >
                Choose the plan that works best for your needs.
            </p>
        </div>
        <div class="pt-24 flex flex-row">
            <!-- Basic Card -->
            <div
                class="w-96 p-8 bg-white text-center rounded-3xl pr-16 shadow-xl border-gray-100 border-4"
            >
                <h1 class="text-black font-semibold text-2xl">
                    Advanced {name2}
                </h1>
                <p class="pt-2 tracking-wide">
                    <span class="text-gray-400 align-top">$ </span>
                    <span class="text-3xl font-semibold">{price2}</span>
                    <span class="text-gray-400 font-medium">/ month</span>
                </p>
                <hr class="mt-4 border-1 mb-3" />
                <PriceInfo
                    color={true}
                    firstName={"radio-0"}
                    secondName={"radio-1"}
                    cpu={cpu2}
                    ram={ram2}
                    paypalLink={paypalLink2}
                    paypalLinkDE={paypalLink2DE}
                    paypalLinkUSE={paypalLink2USE}
                    paymentLink={paymentLink2}
                    paymentLinkDE={paymentLink2DE}
                    paymentLinkUSE={paymentLink2USE}
                />
            </div>
            <div
                class="w-96 p-9 bg-gray-900 text-center rounded-3xl text-white border-4 shadow-xl transform scale-125 border-red-400 border-5"
            >
                <h1 class="text-white font-semibold text-2xl">
                    Ultimate {name4}
                </h1>
                <p class="pt-2 tracking-wide">
                    <span class="text-gray-400 align-top">$ </span>
                    <span class="text-3xl font-semibold">{price4}</span>
                    <span class="text-gray-400 font-medium">/ month</span>
                </p>
                <hr class="mt-4 border-1 border-gray-600" />
                <PriceInfo
                    color={false}
                    firstName={"radio-2"}
                    secondName={"radio-3"}
                    cpu={cpu4}
                    ram={ram4}
                    paypalLink={paypalLink4}
                    paypalLinkDE={paypalLink4DE}
                    paypalLinkUSE={paypalLink4USE}
                    paymentLink={paymentLink4}
                    paymentLinkDE={paymentLink4DE}
                    paymentLinkUSE={paymentLink4USE}
                />
                <div class="absolute top-0 w-90 left-5 right-5 m-1 p-0">
                    <p
                        class="bg-gradient-to-r from-yellow-500 to-red-500 font-semibold px-4 py-1 rounded-full uppercase text-xs"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4 inline-block"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
                            />
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
                            />
                        </svg>MOST POPULAR
                    </p>
                </div>
            </div>
            <div
                class="w-96 p-8 bg-white text-center rounded-3xl pl-16 shadow-xl border-gray-100 border-4"
            >
                <h1 class="text-black font-semibold text-2xl">
                    Premium {name3}
                </h1>
                <p class="pt-2 tracking-wide">
                    <span class="text-gray-400 align-top">$ </span>
                    <span class="text-3xl font-semibold">{price3}</span>
                    <span class="text-gray-400 font-medium">/ month</span>
                </p>
                <hr class="mt-4 border-1" />
                <PriceInfo
                    color={true}
                    firstName={"radio-40"}
                    secondName={"radio-5"}
                    cpu={cpu3}
                    ram={ram3}
                    paypalLink={paypalLink3}
                    paypalLinkDE={paypalLink3DE}
                    paypalLinkUSE={paypalLink3USE}
                    paymentLink={paymentLink3}
                    paymentLinkDE={paymentLink3DE}
                    paymentLinkUSE={paymentLink3USE}
                />
            </div>
        </div>
    </div>
</div>
<div class="">
    <div
        class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between"
    >
        <h2
            class="text-3xl font-extrabold tracking-tight text-gray-400 sm:text-4xl"
        >
            <span class="block">Just testing out?</span>
            <span class="block text-5xl font-extrabold text-gray-50"
                >Try our <span
                    class="inline text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-red-500 to-red-600"
                    >Basic</span
                >
                {name} Plan!</span
            >
            <span class="text-lg font-semibold">
                <span
                    class="inline text-transparent bg-clip-text bg-gradient-to-br from-yellow-500 to-yellow-600"
                    >{cpu}</span
                ><span class="text-gray-50"> &bull; </span>
                <span
                    class="inline text-transparent bg-clip-text bg-gradient-to-br from-green-500 to-blue-600"
                    >{ram}</span
                ><span class="text-gray-50"> &bull; </span>
                <span
                    class="inline text-transparent bg-clip-text bg-gradient-to-br from-blue-600 to-pink-500"
                    >Unmetered NvME SSD</span
                ><span class="text-gray-50"> &bull; </span>
                <span
                    class="inline text-transparent bg-clip-text bg-gradient-to-br from-gray-50 to-gray-500"
                    >All features from other plans</span
                ><span class="text-gray-50" />
            </span>
        </h2>

        <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
            <div class="inline-flex rounded-md shadow">
                <a
                    href={paypalLink}
                    class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-br from-blue-600 to-blue-700 hover:from-indigo-600 hover:to-indigo-700"
                >
                    Checkout with PayPal
                </a>
            </div>
            <div class="ml-3 inline-flex rounded-md shadow">
                <a
                    href={paymentLink}
                    class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-br from-yellow-500 to-red-600 hover:from-yellow-600 hover:to-red-700"
                >
                    Checkout with Credit Card
                </a>
            </div>
        </div>
    </div>
</div>
